export const initCTA = () => {
    const cta = document.querySelector('.cta__go');

    cta.addEventListener('click', () => {
        window.location.href = 'mailto:hello@inteum.pl';
    });
};
